class Profile extends HTMLElement {
  constructor() {
    super();
    
    this.switchContentVisibility = this.switchContentVisibility.bind(this);
    this.hideContent = this.hideContent.bind(this);
    this.showContent = this.showContent.bind(this);
  }

  initialize() {
    this.nodes = {
      menuContainer: this.querySelector('.cms-profile-menu-container'),
    };
  }
  
  connectedCallback() {
    this.initialize();
    
    this.addEventListener('click', this.switchContentVisibility, false);
    document.addEventListener('click', this.hideContent, false);
  }
  
  disconnectedCallback() {
    this.removeEventListener('click', this.switchContentVisibility, false);
    document.removeEventListener('click', this.hideContent, false);
  }
  
  switchContentVisibility(event) {
    if (event.target.closest('.cms-profile-menu__link')) {
      event.stopPropagation();
      return;
    }
    
    if (this.nodes.menuContainer.hidden) {
      /**
       * We don't use `event.stopPropagation()` to avoid unexpected side effects.
       * For instance, some other components may listen to `click` event on the document
       * and execute some code (ws-language-selector is closed after document click)
       * */
      
      this.skipHide = true;
      // Workaround to show focus state on iOS devices after tap on button
      this.querySelector('.cms-profile-menu-button').focus();
      this.showContent();
      return;
    }

    this.hideContent();
  }
  
  hideContent() {
    if (this.skipHide) {
      this.skipHide = false;
      return;
    }
    
    this.nodes.menuContainer.hidden = true;
  }
  
  showContent() {
    this.nodes.menuContainer.hidden = false
  }
}

customElements.define('cms-profile', Profile);
